import { NavigateFunction } from 'react-router-dom';
import { readStoredJson } from './util';

/**
 * 예약 마법사(건강검진 / 심리·건강상담)가 동작하는 데 반드시 필요한 localStorage 값.
 *
 * 이 값들은 예약 시작 화면(`Reservation.tsx` / `ReservationCounsel.tsx`)에서 가족을
 * 고를 때 저장된다. 즉 마법사 단계 화면에 그 과정을 거치지 않고 도달하면 값이 없다.
 * 앱을 껐다 켜거나, 결제 리다이렉트로 중간 단계에 바로 들어오거나, 뒤로가기로
 * 되돌아오는 경우가 그렇다.
 *
 * 예전에는 각 단계가 `JSON.parse(localStorage.getItem(k) || '')` 로 읽었는데,
 * 키가 없으면 `JSON.parse('')` 가 SyntaxError 를 던졌다. 렌더 중이면 화면 전체가
 * 흰 화면이 되고, useEffect 안이면 그 뒤의 api 호출이 통째로 실행되지 않아
 * 빈 화면에서 멈춘 것처럼 보였다.
 */
export const RESERVATION_CONTEXT_KEYS = ['companyInfo', 'FAM_INFO'];

/** 없는 키 목록. 비어 있으면 마법사를 진행해도 된다. */
export function missingReservationContext(): string[] {
  return RESERVATION_CONTEXT_KEYS.filter((key) => readStoredJson(key) === null);
}

/**
 * 마법사 진입 시 호출한다. 필요한 값이 없으면 사용자에게 알리고 예약 시작 화면으로
 * 되돌린다. 값이 갖춰져 있으면 아무 것도 하지 않는다.
 *
 * @param startPath 되돌려 보낼 예약 시작 경로 ('/reservation' | '/reservationCounsel')
 * @returns 되돌렸으면 true (호출부는 이후 로직을 건너뛴다)
 */
export function bounceIfContextMissing(
  navigate: NavigateFunction,
  startPath: string,
): boolean {
  if (missingReservationContext().length === 0) {
    return false;
  }
  alert('예약 정보가 만료되었습니다.\n처음부터 다시 진행해 주세요.');
  // replace — 되돌린 화면에서 뒤로가기로 다시 이 빈 상태에 들어오지 않게 한다
  navigate(startPath, { replace: true });
  return true;
}
